import { classnames } from '@aibees/shared/utils';
import { Button } from '@mui/material';
import { memo } from 'react';
import * as Styled from './styles';
import * as SX from './sx';
import type { DialogFooterProps as Props } from './types';

export const DialogFooter = memo(({ className, onConfirm }: Props) => {
  const handleConfirm = () => {
    onConfirm?.();
  };

  return (
    <Styled.Wrapper
      className={classnames('DialogFooter', className)}
      sx={SX.root}
    >
      <Button
        variant="contained"
        color="primary"
        onClick={handleConfirm}
        size="small"
      >
        Continue
      </Button>
    </Styled.Wrapper>
  );
});

DialogFooter.displayName = 'DialogFooter';
